import { studioSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

export const signatureCard = {
  element: '#studio > div.page-content > div.container-fluid > div > div:nth-child(1)',
  popover: {
    title: 'Signature Card',
    description:
      'The signature card provides a quick overview of the signature. To manage a signature click on the <code><i class="os-icon-more-horizontal"></i></code> button and select an action from the avaliable options, or simply click on the card to view the signature details.',
    side: 'right',
    align: 'center'
  }
};

export const cardWarnings = {
  element: '#studio > div.page-content > div.container-fluid > div > div:nth-child(1) > div.signature-card--header',
  popover: {
    title: 'Signature Card Warnings',
    description: `
        If a signature has any warnings, they'll show up here—making it easy to spot and fix issues. Hover over the icon to see more details about the warning.
        <br/><br/>
        <strong>Warnings</strong>
        <br/>
        <ul>
          <li>HTML lint issues</li>
          <li>Missing fields</li>
          <li>Non-secure URLS</li>
          <li>Smart domain misconfiguration</li>
          <li>3rd-party URL usage</li>
          <li>Unused fields</li>
        </ul>
      `,
    side: 'right',
    align: 'center',
    onNextClick: () => {
      studioSettingsStore.update((studio) => {
        return {
          ...studio,
          tours: {
            ...studio.tours,
            overviewHasToured: true
          }
        };
      });

      GLOBAL_DRIVER_OBJECT.destroy();
    }
  }
};
